// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"NotFound_notFoundContainer__govJv","heading":"NotFound_heading__LPapQ","paragraph":"NotFound_paragraph__JxOgm"};